import Scrollable from "./Scrollable.svelte";
import Simple from "./Simple.svelte";
import type { Facet, IntervalFacet, FacetOptions, FacetVisibility } from "./type";
import { addNameAndFeatureTracking } from "./facetValues";
import ConfigurableFacet from "./ConfigurableFacet.svelte";
import "./filterSection.scss";
import "./filterSheet.scss";
import { type Writable, writable } from "svelte/store";
import type { FacetValue } from "../facet-value";

export { Scrollable, Simple, ConfigurableFacet, addNameAndFeatureTracking };
export type { Facet, IntervalFacet, FacetOptions, FacetVisibility };

/*                                     */
export const globalPopularValues: Writable<FacetValue[]> = writable([]);
